import { QuoteStatus } from 'src/redux/types/quoteSlice';
import { call } from '../@';

export type QuoteUserPayload = {
	givenNames: string;
	lastNames: string;
	email: string;
	phone?: string;
};

export type UpdateQuotePayload = {
	id: string;
	status: QuoteStatus;
	clients: QuoteUserPayload[];
	intermediaries: QuoteUserPayload[];
	referrers: QuoteUserPayload[];
};

export default async function updateQuote(payload: UpdateQuotePayload) {
	return await call('updateQuote', payload);
}
